import React from 'react';
import './loader.css';

const Loader: React.FC = () => {
  return <div className='dots'></div>;
};

export default Loader;
